import type { PageMeta } from "./seo";
import example from "@/content/apex-example.json";
import { APEX_EDITORIAL_PATH } from "../../../../lib/copy/src/apex-editorial-route.mjs";

export function apexEditorialMeta(origin: string, brand: string): PageMeta {
  const canonical = new URL(APEX_EDITORIAL_PATH, origin).href;
  const title = `APEX Score: Classic Car Rating Explained | ${brand}`;
  const description = "Discover the APEX Score: seven factors behind our 100-point classic-car rating, its Elite, Classic and Watch tiers, and how to find your car’s score.";
  return {
    title, description, canonical, ogImage: example.image.large,
    ogType: "website", ogLocale: "en_US", hreflang: [],
    jsonLd: {
      "@context": "https://schema.org",
      "@graph": [
        { "@type": "WebPage", "@id": canonical, url: canonical, name: title,
          description, inLanguage: "en", about: { "@type": "Thing", name: "APEX Score" },
          breadcrumb: { "@id": `${canonical}#breadcrumbs` } },
        { "@type": "BreadcrumbList", "@id": `${canonical}#breadcrumbs`, itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: origin },
          { "@type": "ListItem", position: 2, name: "APEX Score", item: canonical },
        ] },
      ],
    },
  };
}
